<template>
  <div id="app">
    <router-view />
    <div id="loading">
      <img src="@/assets/img/loading.svg">
    </div>
  </div>
</template>
<script>
  export default {
    created() {
      this.$store.dispatch('auth/checkAuthentication');
    },
    watch:{
      $route (to, from){
        localStorage.setItem("return", to.path);
      }
    }
  }
</script>